import {
    changeSelected,
    highlightersSorted,
} from "@store/highlights"
import { updateHtmlClass } from "@utils/directives/useCSSObserver"
import {
    generateHotKeyStore,
    generateHotKeyTapStore,
} from "@utils/underhood/registerHotkey"
import { derived, get } from "svelte/store"

window.addEventListener("keypress", (e) => {
    if (!get(highlightMode)) return

    const harr = [...get(highlightersSorted).keys()]
    const f = +e.key
    if (Number.isNaN(f)) return
    if (f - 1 in harr) {
        changeSelected(harr[f - 1])
        window.dispatchEvent(
            new CustomEvent("highlighter", { detail: harr[f - 1] })
        )
    }
})

// window.addEventListener("keydown", e => {
//     if (e.key == "z") highlightMode.set(true)
// })

// window.addEventListener("keyup", e => {
//     if (e.key == "z") highlightMode.set(false)
// })

const zdown = generateHotKeyStore("z")
const xtoggle = generateHotKeyTapStore("x")

export const highlightMode = derived(
    [zdown, xtoggle],
    ([z, x]) => {
        return z || x
    },
    false
)

highlightMode.subscribe((h) => updateHtmlClass("highlight-mode", h))
